import React from 'react';
import ProductCard from './ProductCard';

const Products = ({ products = [], onAddToCart, onItemClick, cartList = [], className }) => {
    return (
        <div className={className} style={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: '2px',
            width: '100%',
            boxSizing: 'border-box',
            backgroundColor: '#FBFBFC'
        }}>

            <br/>
            <div style={{ width: '100%', textAlign: 'center' }}>
             </div>
            <br/>

            {products.map((product) => (
                <ProductCard 
                    key={product.item_id ?? product.id}
                    product={product}
                    onAddToCart={onAddToCart}
                    onItemClick={onItemClick}
                    cartList={cartList}
                />
            ))}
        </div>
    );
};

export default Products;
